/**
 * Set localStorage item and dispatch custom event for same-tab reactivity
 */
export const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);

  // Dispatch custom event for same-tab listeners
  window.dispatchEvent(
    new CustomEvent('localStorageChange', {
      detail: { key, newValue: value }
    })
  );
};

/**
 * Remove localStorage item and dispatch custom event for same-tab reactivity
 */
export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);

  // Dispatch custom event for same-tab listeners
  window.dispatchEvent(
    new CustomEvent('localStorageChange', {
      detail: { key, newValue: null }
    })
  );
};
